import { AskTripUpdateOutput } from '@allocab/allocab-commons-shared-types';
import { PassengerAskTripUpdateInput } from '@allocab/allocab-passenger-shared-types';
import { useMutation } from '@tanstack/react-query';

import { passengerApi } from '../services/network/Api';

type Input = PassengerAskTripUpdateInput & { key: string };

const askUpdate = ({ key, ...input }: Input) =>
  passengerApi.post<PassengerAskTripUpdateInput, AskTripUpdateOutput>(`v2/trip/${key}/ask-update`, input);

export const useAskUpdate = () => {
  return useMutation<AskTripUpdateOutput, unknown, Input>({
    mutationFn: askUpdate,
  });
};
